<template>
    <b-modal id="login-modal" modal-class="account-modal" hide-header hide-footer>
        <button type="button" class="login-modal-close" @click="hideLoginModal"></button>
        <div class="login-r-bar">
            <div class="show-error-msg" v-if="errorMessage">{{errorMessage}}</div>
            <b-form>
                <b-form-group>
                    <b-form-input v-model="loginForm.username" placeholder="账号"/>
                </b-form-group>
                <b-form-group>
                    <b-form-input v-model="loginForm.password" type="password" placeholder="密码"/>
                </b-form-group>
                <b-btn class="btn-login" @click="login">立即登录</b-btn>
            </b-form>
            <div class="account-login">
                <p class="go-reg-p go-login-p">
                     没有账号？ <a href="javascript:" @click="hideLoginModal" class="user-pa-btn" v-b-modal:register-modal>免费注册</a> /
                    <a href="javascript:" class="user-pa-btn" v-b-modal:reset-password-modal>忘记密码</a>
                </p>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {token} from "@/api/auth/oauth";
    import {mapGetters} from "vuex";

    export default {
        name: "loginAlert",
        computed: {
            ...mapGetters(["remember_me"])
        },
        watch: {
            remember(n) {
                this.$store.commit('SET_REMEMBER_ME', n);
            }
        },
        data() {
            return {
                errorMessage: '',
                loginForm: {
                    username: '',
                    password: ''
                },
                remember: true
            }
        },
        mounted() {
            this.remember = this.remember_me;
        },
        methods: {
            hideLoginModal() {
                this.$bvModal.hide('login-modal');
            },
            login() {
                this.errorMessage = '';
                token(this.loginForm).then(user => {
                    return this.$store.dispatch('login', user);
                }).then(() => {
                    this.hideLoginModal();
                    // 刷新权限渲染
                    this.$router.go(0);
                }).catch(()=>{});
            }
        }
    }
</script>

<style scoped>

</style>
